import styled from 'styled-components';
import { reachMetrikaGoal } from '../../utils/reachMetrikaGoal';
import { openIntership } from '../../utils/openIntership';
import { Modal } from '../shared/Modal';
import { BackgroundScreen } from '../shared/BackgroundScreen';
import { Text } from '../shared/texts';
import { Button } from '../shared/Button';

const ButtonStyled = styled(Button)`
  margin: 16px auto 0;
  max-width: 194px;
`;

const ModalStyled = styled(Modal)`
  min-height: 228px;
  height: 228px;
  justify-content: center;
`;

export const Screen7 = () => {
    const handleInterClick = () => {
        reachMetrikaGoal('lvl3_intership');
        setTimeout(() => openIntership(), 0);
    }

    return (
        <BackgroundScreen>
            <ModalStyled btnType={'secondary'} type={'secondary'}>
                <Text>
                    Не откладывай карьеру {'\n'}на потом — давай к нам {'\n'}уже сейчас!
                </Text>
                <ButtonStyled type={'secondaryOutlined'} onClick={handleInterClick}>На стажировку</ButtonStyled>
            </ModalStyled>
        </BackgroundScreen>
    );
};
